import { getSubjectColorIndex } from "@/lib/strapi/formatters";
import { Text } from "@mantine/core";
import { Resources } from "@tsTypes/subject-schema";
import { buildFullPath } from "@utils/routing";
import Link from "next/link";
import SubTopicTitle from "../../../titles/SubTopicTitle";
import classes from "./SubTopicButton.module.css";

export function SubTopicButton({
  subTopicDocumentId,
  resource,
  subjectNameLower,
  topicIndex,
  topicTitle,
  subTopicNumber,
  subTopicTitle,
  subTopicDescription,
  subTopicIsHigherLevel,
  topicLevel,
  topicNumber,
}: {
  subTopicDocumentId: string;
  resource: Resources;
  subjectNameLower: string;
  topicIndex: number;
  topicTitle: string;
  subTopicNumber?: number;
  subTopicTitle?: string;
  subTopicDescription: string;
  subTopicIsHigherLevel?: boolean;
  topicLevel?: boolean;
  topicNumber?: string;
}) {
  const subjectColorIndex = getSubjectColorIndex(subjectNameLower);
  let href: string = buildFullPath({
    subject: subjectNameLower,
    resource: resource,
    topicNumber: topicIndex.toString(),
    topicTitle: topicTitle,
    subTopicTitle: subTopicTitle,
  });
  return (
    <Link
      className={classes.wrapper}
      href={href}
      title={
        topicLevel
          ? `Topic ${topicNumber}: ${topicTitle}`
          : subTopicNumber
            ? `Subtopic ${subTopicNumber?.toString()}: ${subTopicTitle}`
            : "All subtopics"
      }
      style={
        {
          "--stb-c1": `var(--mantine-color-${subjectColorIndex}-1)`,
          "--stb-c5": `var(--mantine-color-${subjectColorIndex}-5)`,
        } as React.CSSProperties
      }
    >
      <Text className={classes.title}>
        {topicLevel ? (
          <>
            Topic {topicNumber}: {topicTitle}
          </>
        ) : subTopicNumber &&
          subTopicTitle &&
          subTopicIsHigherLevel !== undefined ? (
          <SubTopicTitle
            subjectColorIndex={subjectColorIndex}
            subTopicDocumentId={subTopicDocumentId}
          />
        ) : (
          <>{topicIndex}: All sub-topics combined</>
        )}
      </Text>
      <Text
        component="div"
        className={classes.description}
        dangerouslySetInnerHTML={{
          __html: subTopicDescription,
        }}
      />
    </Link>
  );
}
